<template>
    <Transition
      name="footer"
      id="modalBannerPlanUnique"
    >
      <div v-if="optionsPlanUnique.showFooter" class="">
        <div class="modal-container-footer">
          <div class="modal-header-footer">
            <button class="close-black" @click="closeModalBannerPlanUnique()">
              <img
                src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
                alt="Close" class="close-modal"
              />
            </button>
          </div>
          <div class="modal-body-footer">
            <a :href="link">
              <img
                :src="optionsPlanUnique.image"
                alt="Promotional Banner"
                title="Promotional banner"
                :width="isMobile ? 391 : 1230"
                :height="isMobile ? 48 : 150"
              />
            </a>
          </div>
        </div>
      </div>
    </Transition>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  import { mapActions, mapState } from "pinia";
  import { localeStore } from "stores/locale";
  import { userStore } from "stores/user";
  import { isMobile } from "views/shared/utils/mobile";
  import { planStore } from "stores/plans";  
  
  export default defineComponent({
    name: "ModalBannerPlanUnique",
    props: ["optionsPlanUnique"],
    data() {
      return {
        isMobile: isMobile(),
        link: "/pt-br/assine",        
      };
    },
    methods: {
      ...mapActions(planStore, ["setCloseBanner"]),
      closeModalBannerPlanUnique() {
        this.setCloseBanner(true)
        this.optionsPlanUnique.showFooter = false
      },
    }
  });
  </script>
  
  <style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }
  
  .modal-mask-footer {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }
  
  .modal-container {
    position: fixed;
    z-index: 9998;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 700px;
    margin: auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  
  .modal-container-footer {
    z-index: 9999;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    opacity: 0.8;
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%);
  }
  .modal-header,
  .modal-header-footer {
    display: block;
    text-align: center;
  }
  
  .modal-body,
  .modal-body-footer {
    margin: 0;
    padding: 0px 0px;
  }
  
  .modal-default-button {
    float: right;
  }
  
  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */
  
  .modal-enter-from {
    opacity: 0;
  }
  
  .modal-leave-to {
    opacity: 0;
  }
  
  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  
  .close-black {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
  }
  
  :deep(.modal-body img) {
    width: 100%;
  }
  
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .modal-container,
    .modal-container-footer {
      width: 95%;
    }
  
    :deep(.modal-body-footer img) {
      width: 100%;
    }

    .close-modal {
        width: 30px;
        height: 30px;
    }   

  }
  </style>
  